import { useState } from "react";
import { api } from "../api";
import { ThemeToggle } from "./ThemeToggle";
import type { Theme } from "./ThemeToggle";

export function Login({
  onSuccess,
  theme,
  onToggleTheme,
}: {
  onSuccess: () => void;
  theme: Theme;
  onToggleTheme: () => void;
}) {
  const [psk, setPsk] = useState("");
  const [error, setError] = useState<string | null>(null);
  const [busy, setBusy] = useState(false);

  async function submit(event: React.FormEvent) {
    event.preventDefault();
    if (!psk || busy) return;
    setBusy(true);
    setError(null);
    try {
      await api.login(psk);
      onSuccess();
    } catch (cause) {
      setError(cause instanceof Error ? cause.message : "Sign-in failed");
      setPsk("");
    } finally {
      setBusy(false);
    }
  }

  return (
    <div className="login-wrap">
      <form className="login" onSubmit={submit}>
        <div className="head">
          <div style={{ display: "flex", flexDirection: "column", gap: 4 }}>
            <div className="kicker">arXiv Monitor</div>
            <div className="title">Sign in</div>
          </div>
          <ThemeToggle theme={theme} onToggle={onToggleTheme} />
        </div>

        <div className="panel" style={{ display: "flex", flexDirection: "column", gap: 12 }}>
          <div className="section-label">Passphrase</div>
          <input
            className="input"
            type="password"
            value={psk}
            autoFocus
            autoComplete="current-password"
            placeholder="Enter the shared passphrase"
            onChange={(event) => setPsk(event.target.value)}
          />
          {error ? <div className="error">{error}</div> : null}
          <button className="btn btn-primary" type="submit" disabled={!psk || busy}>
            {busy ? "Checking…" : "Unlock"}
          </button>
        </div>

        <div className="foot">Sessions last 24 hours</div>
      </form>
    </div>
  );
}
